import {Icon} from "@iconify/react"


export default [
    {
        icon:(<Icon className="w-full h-full" icon="icon-park-outline:code-computer"/>),
        title:"Software Development",
        text:"Our focus is on coding software applications for web, mobile, and desktop platforms, including frontend (User Interface) and backend (Server work) development."
    },
    {
        icon:(<Icon className="w-full h-full" icon="icon-park-solid:analysis" />),
        title:"Requirement Analysis",
        text:"Understanding client needs involves gathering requirements, defining project scopes, and creating detailed software specifications through close collaboration."
    },
    {
        icon:(<Icon className="w-full h-full" icon="fluent-mdl2:design" />),
        title:"Design & Architecture",
        text:"After establishing requirements, developers design the architecture and user interface, crafting wireframes, mockups, and defining software structure."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Coding & Development",
        text:"Once requirements are set, developers design the application's architecture and user interface, creating wireframes, mockups, and defining software structure."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Quality & Assurance",
        text:"Our Quality and Assurance professionals test software, identifying and fixing bugs, ensuring it meets client requirements and performs as expected."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Project Management",
        text:"Our Project managers oversee software development, setting timelines, managing resources, and ensuring projects stay on track and within budget."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Deployment & Implementation",
        text:"After thorough testing and approval, the software is deployed, which may include server setup, database configuration, and adapting it to the client's environment."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Maintenance & Support",
        text:"After deployment, BELSOFT SYSTEMS LTD provides ongoing maintenance, updates, and support to address issues, ensure security, and add new features."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Client Communication",
        text:"Regular client communication ensures needs are met, including progress updates, addressing concerns, and obtaining feedback for improvement."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Research & Development",
        text:"We invest in R&D to stay current with technological advancements, which helps us offer innovative solutions and keep software competitive in the market."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Documentation",
        text:"Proper documentation of the software, its design, code, and user manuals is crucial for reference and future maintenance"
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Training",
        text:"Offering training and support to clients and end-users to ensure they can effectively use the software or any other existing softwares"
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Marketing & Sales",
        text:"Promoting the software to potential clients and managing the sales process, which includes understanding market needs and competition."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Legal & Compliance",
        text:"Addressing legal and regulatory requirements, including software licensing, data privacy, and intellectual property protection."
    },
    {
        icon:(<Icon className="w-full h-full" icon="carbon:document"/>),
        title:"Collaborative & teamwork",
        text:"A collaborative environment where developers, designers, testers, and other professionals work together to create successful software products."
    }
]